import { initializeApp } from 'firebase/app';

import { ENV } from '../../config/env.js';

export const firebaseApp = initializeApp(ENV.firebase);
